import { useTranslation } from 'react-i18next';
import { UserX } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Shown when a still-logged-in session is detected as belonging to a deleted account (see
 * `src/lib/sessionValidation.ts`). Standalone — rendered outside the router so it works even after
 * sign-out. `onDismiss` sends the user back to a clean logged-out entry point.
 */
export function AccountDeletedScreen({ onDismiss }: { onDismiss: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <div className="w-full max-w-sm rounded-lg border p-6 text-center">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10">
          <UserX className="h-6 w-6 text-destructive" />
        </div>
        <h1 className="text-lg font-semibold">{t('account_deleted.title')}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('account_deleted.body')}</p>
        <Button className="mt-5 w-full" onClick={onDismiss}>
          {t('account_deleted.cta')}
        </Button>
      </div>
    </div>
  );
}
